import ReactFlow, { Background, Controls, ReactFlowProvider } from 'reactflow';
import 'reactflow/dist/style.css';
import { Box, Button } from '@mui/material';
import { OrgNode } from './OrgNode';
import '../styles/organogram.css';
import { useOrganogramContext } from '../hooks/useOrganogramContext';
import { NodeModal } from './NodeModal';
import { IconPlus } from '@tabler/icons-react';

const nodeTypes = {
    orgNode: OrgNode
};

export default function Organogram() {
    const {
        nodes,
        edges,
        onNodesChange,
        onEdgesChange,
        onConnect,
        addNewNode,
        isViewMode,
    } = useOrganogramContext();

    return (
        <Box className="organogram-container">
            <ReactFlowProvider>
                <Box sx={{ height: '100%', position: 'relative' }}>
                    <Box className="edit-mode-controls">
                        <Button
                            variant="contained"
                            onClick={addNewNode}
                            color="secondary"
                            disabled={isViewMode}
                        >
                            <IconPlus />
                        </Button>
                    </Box>
                    <ReactFlow
                        nodes={nodes}
                        edges={edges}
                        onNodesChange={onNodesChange}
                        onEdgesChange={onEdgesChange}
                        onConnect={onConnect}
                        nodeTypes={nodeTypes}
                        fitView
                        fitViewOptions={{ padding: 0.2 }}
                        nodesDraggable={!isViewMode}
                        nodesConnectable={!isViewMode}
                        elementsSelectable={true}
                        zoomOnDoubleClick={!isViewMode}
                        connectionLineType="default"
                        defaultEdgeOptions={{
                            type: 'default',
                            animated: true,
                            style: {
                                curvature: 0.2
                            },
                            markerEnd: {
                                type: 'arrowclosed',
                                width: 20,
                                height: 20,
                            }
                        }}
                        deleteKeyCode={['Backspace', 'Delete']}
                        snapToGrid={true}
                        snapGrid={[15, 15]}
                    >
                        <Background />
                        <Controls />
                    </ReactFlow>
                    <NodeModal />
                </Box>
            </ReactFlowProvider>
        </Box>
    );
}
